class CustomHeader extends HTMLElement {
  constructor () {
    super()
  }

  connectedCallback () {
    const mobileNav = this.querySelector('.mobile-nav')
    const openBtn = this.querySelector('.menu--toggle')
    const closeBtn = this.querySelector('.mobile-nav--close')
    const mobileNavItems = this.querySelectorAll('.has-sub-nav')
    openBtn.addEventListener('click', (ev) => {
      mobileNav.classList.toggle('active')
    })
    closeBtn.addEventListener('click', (ev) => {
      mobileNav.classList.toggle('active')
    })
    mobileNavItems.forEach(elem=>{
      elem.addEventListener('click', (ev) => {
        elem.classList.toggle('active')
      })
    })

  }

}

customElements.define('custom-header', CustomHeader)
window.onscroll = function() {switchHeaderClass()};

// Get the header
let header = document.querySelector(".shopify-section.custom-header");

// Get the offset position of the navbar
let sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function switchHeaderClass() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}
